// extracted by mini-css-extract-plugin
export default {"subtitle":"SummaryComponent_subtitle__e8WVk","buttons":"SummaryComponent_buttons__6oeL8","notFound":"SummaryComponent_notFound__pG3rB"};